import Vue from 'vue'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'
import { dataFields } from './utils.js'

/**
 * Dados por equipe
 *
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 *
 * @returns {array}
 */
export async function getCadastrosPorEquipe(cod_ibge, nu_ine) {
  try {
    const { data } = await Vue.prototype.$api.get(
      `/app/pessoa-diabetes/${cod_ibge}/equipe/${nu_ine}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

/**
 * Dados por microárea
 *
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 * @param {int} micro_area
 *
 * @returns {array}
 */
export async function getCadastrosPorMicroArea(cod_ibge, nu_ine, micro_area) {
  try {
    const { data } = await Vue.prototype.$api.get(
      `/app/pessoa-diabetes/${cod_ibge}/equipe/${nu_ine}/microarea/${micro_area}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

export function generatePdf(
  cadastros,
  selectEquipe,
  micro_area,
  selectedFilterBoasPraticas
) {
  let title_pdf = 'Pessoa diabética'
  let titlePdfSave = utils.methods.titlePdf('Pessoa diabética')

  let description_pdf = 'Cuidado da pessoa com diabetes'
  let headers_pdf = ['NOME', 'NASCIMENTO', 'MÃE', 'M.ÁREA', 'PENDÊNCIAS']
  var data_pdf = []

  for (let i = 0; i < cadastros.length; i++) {
    var obj = {}
    obj.no_cidadao = cadastros[i].no_cidadao
    obj.dt_nascimento =
      utils.methods.formatDate(cadastros[i].dt_nascimento) +
      `\n(${cadastros[i].idade} ${cadastros[i].idade > 1 ? 'anos' : 'ano'})`
    obj.no_mae = cadastros[i].no_mae
    obj.micro_area = cadastros[i].micro_area
    obj.pendencias = dataFields.Pendências.callback(cadastros[i])
    obj.rowColor = cadastros[i].rowColor
    data_pdf.push(obj)
  }

  let doc = new jsPDF({
    orientation: 'l',
    unit: 'pt',
    format: 'a4',
    ...utils.methods.encryptionPdf(),
  })
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  // let brasao = ''
  let brasao = store.state.infoMunicipio.brasao

  utils.methods
    .fileToBase64(brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf,
        200,
        'l'
      )

      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Equipe',
            value: selectEquipe.no_equipe,
          },
          {
            label: 'CNES',
            value: selectEquipe.nu_cnes,
          },
          {
            label: 'INE',
            value: selectEquipe.nu_ine,
          },
          {
            label: 'Microárea',
            value: micro_area,
          },
          {
            label: 'Boa prática',
            value: selectedFilterBoasPraticas?.label ?? '',
          },
        ],
        verticalPosition,
        'l'
      )

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 12,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 12,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          let color = data.row.raw[5]

          // Header sempre preto
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
            return
          }
          if (color == 'green') {
            doc.setTextColor(2, 99, 57)
            return
          }
          if (color == 'red') {
            doc.setTextColor(194, 10, 16)
            return
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY, 250, 600, 'l')

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export function percentualMunicipio(
  dadosDaTabelaResultado,
  selectedFilterBoasPraticas
) {
  let numerador = 0
  let denominador = 0
  let resultado = 0
  let classificacao = ''

  const hoje = new Date()
  const mesAtual = hoje.getMonth() + 1
  const anoAtual = String(hoje.getFullYear())
  const mesAnoAtual = `${mesAtual}/${anoAtual}`

  const dadosDoMunicipio = dadosDaTabelaResultado.find(
    (item) =>
      item.nivel == 1 &&
      item.ibge === store.state.cod_ibge &&
      item.indicador == 48 &&
      item.mes_ano === mesAnoAtual
  )

  if (dadosDoMunicipio === undefined) {
    return {
      numerador: 0,
      denominador: 0,
      resultado: 0,
      classificacao: '',
    }
  }

  let dados = JSON.parse(dadosDoMunicipio.dados)

  if (
    selectedFilterBoasPraticas == null ||
    selectedFilterBoasPraticas.value == null
  ) {
    numerador = dados.numerador
    denominador = dados.denominador
    resultado = dados.resultado
    classificacao = dados.classificacao
  } else {
    numerador = dados[`num_${selectedFilterBoasPraticas.key_percentual}`]
    denominador = dados.denominador
    resultado = dados[`res_${selectedFilterBoasPraticas.key_percentual}`]
    classificacao = '-'
  }

  return {
    numerador: numerador,
    denominador: denominador,
    resultado: resultado,
    classificacao: classificacao,
  }
}

export function percentualEquipe(
  dadosDaTabelaResultado,
  nuIne,
  selectedFilterBoasPraticas
) {
  let numerador = 0
  let denominador = 0
  let resultado = 0
  let classificacao = ''

  const hoje = new Date()
  const mesAtual = hoje.getMonth() + 1
  const anoAtual = String(hoje.getFullYear())
  const mesAnoAtual = `${mesAtual}/${anoAtual}`

  let dadosDaEquipe = dadosDaTabelaResultado.find(
    (item) =>
      item.nivel == 2 &&
      item.ine === nuIne &&
      item.indicador == 48 &&
      item.mes_ano === mesAnoAtual
  )

  if (dadosDaEquipe === undefined) {
    return {
      numerador: 0,
      denominador: 0,
      resultado: 0,
      classificacao: '',
    }
  }

  let dados = JSON.parse(dadosDaEquipe.dados)

  if (
    selectedFilterBoasPraticas == null ||
    selectedFilterBoasPraticas.value == null
  ) {
    numerador = dados.numerador
    denominador = dados.denominador
    resultado = dados.resultado
    classificacao = dados.classificacao
  } else {
    numerador = dados[`num_${selectedFilterBoasPraticas.key_percentual}`]
    denominador = dados.denominador
    resultado = dados[`res_${selectedFilterBoasPraticas.key_percentual}`]
    classificacao = '-'
  }

  return {
    numerador: numerador,
    denominador: denominador,
    resultado: resultado,
    classificacao: classificacao,
  }
}

export function percentualMicroArea(
  dadosDaTabelaResultado,
  nu_ine,
  micro_area,
  selectedFilterBoasPraticas
) {
  let numerador = 0
  let denominador = 0
  let resultado = 0
  let classificacao = ''

  const hoje = new Date()
  const mesAtual = hoje.getMonth() + 1
  const anoAtual = String(hoje.getFullYear())
  const mesAnoAtual = `${mesAtual}/${anoAtual}`

  let dadosDaMicroArea = dadosDaTabelaResultado.find(
    (item) =>
      item.nivel == 3 &&
      item.ine == nu_ine &&
      item.micro_area === micro_area &&
      item.indicador == 48 &&
      item.mes_ano === mesAnoAtual
  )

  if (dadosDaMicroArea === undefined) {
    return {
      numerador: 0,
      denominador: 0,
      resultado: 0,
      classificacao: classificacao,
    }
  }

  let dados = JSON.parse(dadosDaMicroArea.dados)

  if (
    selectedFilterBoasPraticas == null ||
    selectedFilterBoasPraticas.value == null
  ) {
    numerador = dados.numerador
    denominador = dados.denominador
    resultado = dados.resultado
    classificacao = dados.classificacao
  } else {
    numerador = dados[`num_${selectedFilterBoasPraticas.key_percentual}`]
    denominador = dados.denominador
    resultado = dados[`res_${selectedFilterBoasPraticas.key_percentual}`]
    classificacao = '-'
  }

  return {
    numerador: numerador,
    denominador: denominador,
    resultado: resultado,
    classificacao: classificacao,
  }
}
